// Suggests knowledge base articles for a ticket by simple keyword overlap
// (title matches count most, then category, then body). No search service:
// the KB is small enough to rank in the browser. Returns [] unless something
// genuinely matches, so the suggestions stay quiet rather than noisy.
const STOP_WORDS = new Set([
  'the', 'and', 'for', 'are', 'but', 'not', 'you', 'all', 'can', 'her', 'was', 'one', 'our', 'out', 'has', 'have',
  'had', 'with', 'this', 'that', 'from', 'they', 'will', 'would', 'there', 'their', 'what', 'when', 'your', 'about',
  'which', 'been', 'were', 'please', 'hello', 'thanks', 'thank', 'regards', 'kind', 'help', 'need', 'cannot', 'cant',
  'dont', 'does', 'how', 'why', 'who', 'its', 'any', 'get', 'got', 'just', 'ticket', 'dear'
]);

const tokens = (text) => new Set(
  (String(text || '').toLowerCase().match(/[a-z0-9]{3,}/g) || []).filter((w) => !STOP_WORDS.has(w))
);

const MIN_SCORE = 3;

export const suggestArticles = (articles, text, limit = 3) => {
  const query = tokens(text);
  if (query.size === 0 || !Array.isArray(articles)) return [];

  return articles
    .filter((a) => a && a.published !== false && a.title)
    .map((article) => {
      const title = tokens(article.title);
      const category = tokens(article.category);
      const body = tokens(article.body);
      let score = 0;
      query.forEach((word) => {
        if (title.has(word)) score += 3;
        if (category.has(word)) score += 2;
        if (body.has(word)) score += 1;
      });
      return { article, score };
    })
    .filter((entry) => entry.score >= MIN_SCORE)
    .sort((a, b) => b.score - a.score)
    .slice(0, limit)
    .map((entry) => entry.article);
};
